import DataService from "@/core/base/service/data.service";
import { IMeasuring } from "@/shared/model/measuring.model";

export default class MeasuringService extends DataService<IMeasuring> {

  public getKPIs(): Record<string, string>[] {
    return [
      { key: "paidReach", icon: "fas fa-users-rays" },
      { key: "organicReach", icon: "fas fa-users-rays" },
      { key: "fanReach", icon: "fas fa-users-rays" },
      { key: "reach", icon: "fas fa-users-rays" },
      { key: "reactions", icon: "fas fa-circle" },
      { key: "comments", icon: "fas fa-comment" },
      { key: "impressions", icon: "fas fa-user" },
      { key: "clicks", icon: "fas fa-mouse-pointer" },
      { key: "replies", icon: "fas fa-reply" },
      { key: "like", icon: "fas fa-thumbs-up" },
      { key: "dislike", icon: "fas fa-thumbs-down" },
      { key: "taps_forward", icon: "fas fa-arrow-right" },
      { key: "tap_forward", icon: "fas fa-arrow-right" },
      { key: "swipe_forward", icon: "fas fa-arrow-right" },
      { key: "taps_back", icon: "fas fa-arrow-left" },
      { key: "tap_back", icon: "fas fa-arrow-left" },
      { key: "tap_exit", icon: "fas fa-sign-out" },
      { key: "exits", icon: "fas fa-sign-out" },
      { key: "interactions", icon: "fas fa-hand" },
      { key: "saved", icon: "fas fa-save" },
      { key: "share", icon: "fas fa-share" },
      { key: "views", icon: "fas fa-eye" },
      { key: "average_time_watched", icon: "fas fa-clock" },
      { key: "total_time_watched", icon: "fas fa-clock" },
      { key: "full_video_watched_rate", icon: "fas fa-eye" },
      { key: "spend", icon: "fas fa-dollar-sign" },
      { key: "ctr", icon: "fas fa-chart-line" },
      { key: "frequency", icon: "fas fa-sync" }
    ];
  }

  public getKPIsMap(): Record<string, any> {
    return this.getKPIs().reduce((result, entry) => {
      result[entry.key] = entry;
      return result;
    }, {} as any);
  }

  protected baseApiUrl: string = "api/measuring";
}
